import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      search: '',
      is_new: '',
      status: 'active',
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'payment_profiles::filters.dropdown.items.search.label',
        placeholder: 'benchmarks::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      is_new: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-11'}
            color={'basic-primary-white'}
          />
        ),
        label: 'benchmarks::filters.dropdown.items.is_new.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'benchmarks::filters.dropdown.items.is_new.options.',
        options: ['1', '0'],
      },
      status: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'benchmarks::filters.dropdown.items.status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'benchmarks::filters.dropdown.items.status.options.',
        options: ['archived', 'active'],
      },
    },
  }
}
